<template>
	<div class="resource-type-video margin-bottom-xs-2" v-if="resource">
		<video
			controls
			playsinline
			v-if="resource.video && !resource.youtube_video"
			:ref="'video-' + resource.resource_id"
		>
			<source
				:src="resource.video.url"
				:type="resource.video.mime_type"
			/>
			Din webbläsare stödjer inte video-taggen.
		</video>
		<div class="youtube-video-wrapper" v-if="resource.youtube_video">
			<iframe
				:src="youtubeVideoSrc"
				frameborder="0"
				allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
	</div>
</template>
<script>
export default {
	name: "ResourceTypeVideo",
	props: [],
	components: {},
	computed: {
		resource() {
			return this.$store.state.activeResource;
		},
		youtubeVideoSrc() {
			var src = this.resource.youtube_video.split("?v=")[1];
			return (
				"https://www.youtube.com/embed/" +
				src +
				"?rel=0&showinfo=0&modestbranding=1&playsinline=1"
			);
		}
	},
	methods: {},
	mounted() {
		/* Send to Google Analytics on video play */
		var video = this.$refs["video-" + this.resource.resource_id];
		if (video != undefined) {
			video.addEventListener("play", function() {
				__gaTracker(
					"send",
					"event",
					"Målmedvetet näringsliv",
					"play_video"
				);
			});
		}
	}
};
</script>